export default "__VITE_ASSET__e3de9f90__"